import moment from 'moment-timezone'
import _ from 'lodash'
moment.tz.setDefault('Asia/Tokyo')

// NOTE: 単体テスト用にexportしているだけなので、外部からは基本参照しない
export const initOptions = () => {
  return {
  }
}

const getDefaultState = () => {
  return {
    options: {
      time: moment({ hour: 10 }),
      taxiDistance: 0,
      sort: 'ekispert',
      mode: 'public'
    }
  }
}

const state = getDefaultState()

const getters = {
  getOptions: (state) => state.options,
  getTime: (state) => state.options.time,
  getTaxiDistance: (state) => state.options.taxiDistance,
  getSort: (state) => state.options.sort,
  getMode: (state) => state.options.mode
}

const actions = {
  resetOptions ({ commit }) {
    commit('setOptions', getDefaultState().options)
  },
  resetDetailOptions ({ commit }) {
    commit('setOptions', _.pick(getDefaultState().options, ['taxiDistance', 'sort']))
  },
  updateOptions ({ commit, state }, params) {
    commit('setOptions', Object.assign(state.options, params))
  },
  parseTime ({ commit }) {
    commit('setMoment')
  },
  updateTime ({ commit }, time) {
    commit('setTime', time)
  },
  setMode ({ commit }, mode) {
    commit('setMode', mode)
  },
  reset ({ commit }) {
    commit('resetState')
  }
}

const mutations = {
  setOptions (state, params) {
    state.options = Object.assign(state.options, params)
  },
  setMoment (state) {
    const t = state.options.time
    if (!moment.isMoment(t)) {
      state.options = Object.assign(state.options, { time: moment(t) })
    }
  },
  setTime (state, time) {
    state.options.time = time
  },
  setMode (state, mode) {
    state.options.mode = mode
  },
  resetState (state) {
    Object.assign(state, getDefaultState())
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
